const QUOTES = [
  { text: "Mỗi ngày tốt hơn 1% — sau 1 năm bạn sẽ giỏi hơn 37 lần.", author: "James Clear" },
  { text: "Thành công không phải đích đến, mà là hành trình mỗi ngày.", author: "Zig Ziglar" },
  { text: "Điều duy nhất đứng giữa bạn và mục tiêu là câu chuyện bạn tự kể.", author: "Jordan Belfort" },
  { text: "Không ai có thể quay lại và bắt đầu lại, nhưng ai cũng có thể bắt đầu hôm nay.", author: "Maria Robinson" },
  { text: "Kỷ luật là cầu nối giữa mục tiêu và thành tựu.", author: "Jim Rohn" },
  { text: "Hành động nhỏ mỗi ngày tạo ra kết quả lớn theo thời gian.", author: "Robin Sharma" },
  { text: "Đừng chờ cảm hứng. Hãy bắt đầu — cảm hứng sẽ đến.", author: "Jack London" },
  { text: "Bạn không cần phải vĩ đại để bắt đầu, nhưng phải bắt đầu để trở nên vĩ đại.", author: "Les Brown" },
  { text: "Thói quen tốt là lãi kép của sự phát triển bản thân.", author: "James Clear" },
  { text: "Khó khăn hôm nay là sức mạnh ngày mai.", author: "Robert H. Schuller" },
  { text: "Người thành công làm những gì người thất bại không muốn làm.", author: "Jim Rohn" },
  { text: "Mỗi bước nhỏ hôm nay là nền tảng cho sự thay đổi lớn ngày mai.", author: "Leo Babauta" },
  { text: "Sự kiên nhẫn là chìa khóa của mọi thành tựu.", author: "Bill Gates" },
  { text: "Đừng so sánh với người khác. Hãy so sánh với chính mình ngày hôm qua.", author: "Jordan Peterson" },
  { text: "Thay đổi suy nghĩ, bạn sẽ thay đổi thế giới.", author: "Norman Vincent Peale" },
  { text: "Cách tốt nhất để dự đoán tương lai là tạo ra nó.", author: "Peter Drucker" },
  { text: "Không có thất bại — chỉ có bài học.", author: "Robert Kiyosaki" },
  { text: "Hãy là phiên bản tốt nhất của chính mình, không phải bản sao của ai khác.", author: "Judy Garland" },
  { text: "Thành công là tổng của những nỗ lực nhỏ lặp đi lặp lại mỗi ngày.", author: "Robert Collier" },
  { text: "Bạn mạnh hơn bạn nghĩ, dũng cảm hơn bạn tin, và thông minh hơn bạn tưởng.", author: "A.A. Milne" },
  { text: "Điều quan trọng không phải là tốc độ, mà là hướng đi.", author: "Khuyết danh" },
  { text: "Hôm nay khó, ngày mai khó hơn, nhưng ngày kia sẽ rất đẹp.", author: "Jack Ma" },
  { text: "Gieo suy nghĩ, gặt hành động. Gieo hành động, gặt thói quen. Gieo thói quen, gặt tính cách.", author: "Stephen Covey" },
  { text: "Đừng để ngày hôm qua chiếm quá nhiều ngày hôm nay.", author: "Will Rogers" },
  { text: "Cuộc sống bắt đầu ở nơi vùng an toàn kết thúc.", author: "Neale Donald Walsch" },
  { text: "Người chiến thắng không bao giờ bỏ cuộc, người bỏ cuộc không bao giờ thắng.", author: "Vince Lombardi" },
  { text: "Một năm kể từ bây giờ, bạn sẽ ước mình đã bắt đầu hôm nay.", author: "Karen Lamb" },
  { text: "Sự xuất sắc không phải là hành động, mà là thói quen.", author: "Aristotle" },
  { text: "Đừng đếm ngày — hãy làm cho mỗi ngày đều đáng đếm.", author: "Muhammad Ali" },
  { text: "Bí mật của sự thay đổi là tập trung toàn bộ năng lượng vào xây dựng cái mới.", author: "Socrates" },
];

export function getDailyQuote() {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 86400000);
  return QUOTES[dayOfYear % QUOTES.length];
}
